export const LOYALTY_LANDING_PAGE = 'societe'
export const LOYALTY_TERMS_AND_CONDITIONS_PAGE = 'societe-terms-and-conditions'
export const LEBT_SOCIETE_CAMPAIGN_SLUG = 'lebt-societe-campaign'
